import { createContext, useContext, RefObject } from 'react'

interface ScrollContextValue {
  scrollContainerRef: RefObject<HTMLDivElement | null> | null
}

export const ScrollContext = createContext<ScrollContextValue>({
  scrollContainerRef: null,
})

export const useScrollContainer = () => useContext(ScrollContext)
